import { Choice, Switch } from 'platform/components';
import { match } from 'ts-pattern';
import type { FeGridSettings } from '../../../../types/Api';
import type { LineHeight } from '../../../../utils/lineHeightToValue';
export type SettingsPanelProps = {
  settings: FeGridSettings;
  onSettingsChange: (settings: Partial<FeGridSettings>) => void;
};
type HeightOption = {
  value: LineHeight;
  label: string;
};
type PageSizeOption = {
  value: number;
  label: string;
};
const ROW_HEIGHT_OPTIONS: HeightOption[] = [{
  value: 'COMPACT',
  label: 'Compact'
}, {
  value: 'SHORT',
  label: 'Small'
}, {
  value: 'DEFAULT',
  label: 'Default'
}, {
  value: 'TALL',
  label: 'Tall'
}, {
  value: 'THUMBNAIL',
  label: 'Thumbnail'
}];
const HEADER_HEIGHT_OPTIONS: HeightOption[] = [{
  value: 'COMPACT',
  label: 'Compact'
}, {
  value: 'SHORT',
  label: 'Small'
}, {
  value: 'DEFAULT',
  label: 'Default'
}, {
  value: 'TALL',
  label: 'Tall'
}, {
  value: 'THUMBNAIL',
  label: 'Thumbnail'
}];
const PAGE_SIZE_OPTIONS: PageSizeOption[] = [{
  value: 25,
  label: '25'
}, {
  value: 50,
  label: '50'
}, {
  value: 75,
  label: '75'
}, {
  value: 100,
  label: '100'
}, {
  value: 200,
  label: '200'
}];
export function SettingsPanel(props: SettingsPanelProps) {
  const handleRowHeightChange = (value: string | number | string[] | null) => {
    const heightValue = match(value).with('COMPACT', () => 'COMPACT' as LineHeight).with('SHORT', () => 'SHORT' as LineHeight).with('DEFAULT', () => 'DEFAULT' as LineHeight).with('TALL', () => 'TALL' as LineHeight).with('THUMBNAIL', () => 'THUMBNAIL' as LineHeight).otherwise(() => props.settings.rowHeight);
    props.onSettingsChange({
      rowHeight: heightValue
    });
  };
  const handleHeaderHeightChange = (value: string | number | string[] | null) => {
    const heightValue = match(value).with('COMPACT', () => 'COMPACT' as LineHeight).with('SHORT', () => 'SHORT' as LineHeight).with('DEFAULT', () => 'DEFAULT' as LineHeight).with('TALL', () => 'TALL' as LineHeight).with('THUMBNAIL', () => 'THUMBNAIL' as LineHeight).otherwise(() => props.settings.headerHeight);
    props.onSettingsChange({
      headerHeight: heightValue
    });
  };
  const handlePageSizeChange = (value: string | number | string[] | null) => {
    const numValue = typeof value === 'number' ? value : Number(value);
    props.onSettingsChange({
      itemsPerPage: isNaN(numValue) ? 25 : numValue
    });
  };
  const handleZebraChange = (value: boolean) => {
    props.onSettingsChange({
      stripedRows: value
    });
  };
  const handleHorizontalSeparatorsChange = (value: boolean) => {
    props.onSettingsChange({
      horizontalSeparatorsVisible: value
    });
  };
  const handleVerticalSeparatorsChange = (value: boolean) => {
    props.onSettingsChange({
      verticalSeparatorsVisible: value
    });
  };
  const handleColumnGroupsChange = (value: boolean) => {
    props.onSettingsChange({
      columnGroupsVisible: value
    });
  };
  return <div className="flex flex-col h-full overflow-hidden">
      <div className="flex flex-col gap-4 p-4 overflow-y-auto flex-1">
        <Choice label="Header height" name="headerHeight" options={HEADER_HEIGHT_OPTIONS} value={props.settings.headerHeight} onChange={handleHeaderHeightChange} isNotClearable />
        <Choice label="Row height" name="rowHeight" options={ROW_HEIGHT_OPTIONS} value={props.settings.rowHeight} onChange={handleRowHeightChange} isNotClearable />
        <Choice label="Items per page" name="itemsPerPage" options={PAGE_SIZE_OPTIONS} value={props.settings.itemsPerPage} onChange={handlePageSizeChange} isNotClearable />
        <Switch label="Zebra striping" value={props.settings.stripedRows} onChange={handleZebraChange} />
        <Switch label="Horizontal separators" value={props.settings.horizontalSeparatorsVisible} onChange={handleHorizontalSeparatorsChange} />
        <Switch label="Vertical separators" value={props.settings.verticalSeparatorsVisible} onChange={handleVerticalSeparatorsChange} />
        <Switch label="Column groups" value={props.settings.columnGroupsVisible} onChange={handleColumnGroupsChange} />
      </div>
    </div>;
}